<template>
  <v-chip :color="tag.color" :density="density" prepend-icon="$assetTag" @click:close="() => emit('click:close')">
    <span class="text-high-emphasis">{{ tag.description }}</span>
  </v-chip>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: "click:close"): void
}>()

const { density = "comfortable" } = defineProps<{
  tag: Pick<TagSubset, "color" | "description">
  density?: "comfortable" | "compact" | "default"
}>()
</script>
